import { useDispatch } from "react-redux";
import { showAccountWindowIR, SwitchAccountWindow, toggleAccountWindow } from "../../Actions/VisualDataAction";

const OpenLoginModal = props => {

    const dispatch = useDispatch();

    const isIR = process.env.REACT_APP_SERVER_CULTURE === "IR";

    const openLogin = () => {

        if(isIR){
            dispatch(showAccountWindowIR("usernameModal"));
        }else{
            dispatch(SwitchAccountWindow(false));
            dispatch(toggleAccountWindow());
        }

    };

    return(
        <button
            type="button"
            className="button blue-btn"
            onClick={openLogin}
        >
            {props.text}
        </button>
    )
}

export default OpenLoginModal;